import React from "react"
import { useState } from "react"
import styled from "styled-components"
import { Flex, Icon, scale, colors } from "@capioweb/ui-components/src"

export interface QuickNavigatorProps {
	quickNavigatorLinks: Array<any>
}

export interface FlipIconProps {
	flipped: boolean
}

const QLinksDiv = styled.div`
	background: #f7542b;
	border-top: none;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
	display: inline-block;
	list-style: none;
	margin: 0;
	padding: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 100000;
	cursor: pointer;

	ul {
		background-color: ${colors.grey81};
		border: solid 1px ${colors.white};
		text-align: center;

		li {
			color: ${colors.white};
			display: block;
			font-size: ${scale.px(1.75)} !important;
			line-height: ${scale.px(2)} !important;
			margin: ${scale.px(1)} 0;
			padding: ${scale.px(0.5)} ${scale.px(2.5)};
			white-space: nowrap;

			&:hover {
				background-color: ${colors.coral100};
				color: ${colors.white};
			}
		}
	}
`
const EpiLogoContainer = styled.div`
	background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iRXBpc2VydmVyX0xvZ28iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE0MS43MyA1OC4xOCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5FcGlfd2hpdGU8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTcxLjQ4LDEzLjUzYzAtNCwyLjM0LTcsNi4xNS03czYuMjEsMi44MSw2LjIxLDYuODZWMjkuNTNjMCwzLjc1LTEuNTIsNy4yNy02LjUsNy4yN0g3NS43NnY2LjQ1aDEuNThjNC42MywwLDcuMTUtMS42NCwxMS4wNy01LjU3TDExNS4wNywxMVYzNC4yMmMwLDYuNTYsMy44Nyw5LjMyLDguMjYsOS4zMiwzLDAsNC44LTEuMDUsNy41Ni0zLjgxbDEwLjg0LTEwLjg0LTQuNDUtNC4yMi0xMSwxMC44NGMtMS40NiwxLjQxLTIuMTEsMS42NC0yLjcsMS42NGEyLjMsMi4zLDAsMCwxLTIuMjktMi41OFYzLjg3YzAtMi0xLTMuNTctMy4xMS0zLjU3LTAuODgsMC0xLjY0LjI5LTMuMTYsMS44MmwtMjUsMjVWMTIuNDJBMTIuNDgsMTIuNDgsMCwwLDAsNzcuNjMsMEM3My44OCwwLDcxLjI1LDEuMjMsNjcuNSw1TDM4LjIsMzQuMjhjLTIuMTcsMi4xNy0zLjQsMi44Ny01LjUxLDIuODdBNi4xOCw2LjE4LDAsMCwxLDI2LjYsMzFMNDQuMjQsMTMuM2EzLjI4LDMuMjgsMCwwLDAsLjk0LTIuN0ExMi41OCwxMi41OCwwLDAsMCwzMi44MSwwQzI5LjQxLDAsMjYuNi45NCwyMi41LDVMMCwyNy42LDQuNDUsMzIsMjAuMzMsMTYuMTF2MTRjMCw4LjIsNS40NSwxMy4yNCwxMi40OCwxMy4yNCw0LDAsNi40NS0xLjI5LDEwLTQuODZMNjUuMjEsMTYuMTFWNTguMThoNi4yN1YxMy41M1pNMjYuNiwyMi4xNVYxMi40MmE2LjIxLDYuMjEsMCwwLDEsNi4yMS02LjIxLDYuMzcsNi4zNywwLDAsMSw1LjgsMy45M1oiLz48L3N2Zz4=");
	background-position: center;
	background-repeat: no-repeat;
	display: block;
	min-height: ${scale.px(2)};
	line-height: ${scale.px(1.5)};
	margin: ${scale.px(1)} ${scale.px(1.2)};
	min-width: ${scale.px(8)};
`
const FlipIcon = styled(Flex) <FlipIconProps>`
	transform: ${(props) => (props.flipped ? "rotate(180deg)" : "none")};
`

const QuickNavigatorEpi: React.FC<QuickNavigatorProps> = (props) => {
	const ref = React.useRef() as React.MutableRefObject<HTMLDivElement>
	const [open, setOpen] = useState(false)

	return (
		<div ref={ref}>
			{props.quickNavigatorLinks && props.quickNavigatorLinks.length > 0 && (
				<QLinksDiv onClick={() => setOpen(!open)}>
					<Flex display="flex" justifyContent="space-between">
						<Flex alignItems="center">
							<EpiLogoContainer>
								<span className="visually-hidden">Episerver</span>
							</EpiLogoContainer>
						</Flex>
						<FlipIcon
							display="flex"
							flexDirection="column"
							justifyContent="center"
							flipped={open}
						>
							<Icon color={"white"} icon={"chevron-down"} m={0.5} size={3} />
						</FlipIcon>
					</Flex>
					{open && (
						<ul>
							{props.quickNavigatorLinks.map((item, index) => (
								<li key={index}>
									<a href={item.url}>{item.caption}</a>
								</li>
							))}
						</ul>
					)}
				</QLinksDiv>
			)}
		</div>
	)
}

export { QuickNavigatorEpi }
